<template>
  <div class="section-newsletter" id="section-newsletter">
    <div class="columns is-gapless is-flex-mobile is-centered">
      <div class="column is-8 is-11-mobile">

        <div class="columns is-gapless is-centered is-multiline">
          <div class="column is-6 has-text-centered">
            <div class="cont-desc" data-aos="fade-up" data-aos-once="true">
              <img src="../assets/logo.svg" width="50" style="width:50px;" class="img-responsive" />
            </div>
          </div>
        </div>

        <div class="columns is-gapless is-centered is-multiline">
          <div class="column is-6 has-text-centered">
            <div class="cont-desc" data-aos="fade-up" data-aos-once="true">
              <h3 class="title" style="font-size:1.8em;">Mailing List</h3>
              <span>Stay up to date! Never miss an unforgettable 'Live In Concert' experience by RKOK Live. Subscribe to receive emails on our next big show.</span>
            </div>
          </div>
        </div>

        <div class="columns is-gapless is-multiline">
          <div class="column is-6">
            <div class="cont-form cont-form-info" data-aos="fade-up" data-aos-once="true">
              <b-field>
                <b-input value="" placeholder="NAME" v-model.trim="name" @input="$v.name.$touch()"></b-input>
              </b-field>
            </div>
          </div>

          <div class="column is-6">
            <div class="cont-form cont-form-message" data-aos="fade-up" data-aos-once="true">
              <b-field>
                <b-input value="" placeholder="EMAIL" v-model.trim="email" @input="$v.email.$touch()">
                </b-input>
              </b-field>
              <button class="button submit is-outlined" :class="{ 'is-loading': loading }" @click="onSend($v)">
                <p>{{ loading ? '&nbsp;' : 'SUBSCRIBE' }}</p>
              </button>
              <p v-if="feedback">{{ feedback }}</p>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import Site from '@/apis/Site'
export default {
  name: 'newslettersection',
  mixins: [validationMixin],
  data: function () {
    return {
      name: '',
      email: '',
      // captcha: '',
      // session: '',
      captchaImage: undefined,
      feedback: false,
      loading: false
    }
  },
  mounted: function () {
    // this.onRecaptcha(data => {
    //   console.log('recaptcha data!')
    //   this.captchaImage = data.data
    //   this.session = data.id
    // })
  },
  methods: {
    onRecaptcha: function (onRecaptchaSuccess) {
      // Site.getRecaptcha()
      // .then(data => {
      //   console.log('get recaptcha')
      //   console.log(data)
      //   if (onRecaptchaSuccess) {
      //     onRecaptchaSuccess(data)
      //   }
      // })
      // .catch(error => {
      //   console.log('get recaptcha error')
      //   console.log(error)
      // })
    },
    onSend: function ($v) {
      var _self = this
      if ($v.$invalid) {
        _self.feedback = 'Please fill in all fields to proceed.'
        // _self.$toast.open({
        //   duration: 5000,
        //   message: 'Please fill in all fields to proceed.',
        //   position: 'is-bottom',
        //   type: 'is-warning'
        // })
      } else {
        _self.feedback = false
        _self.loading = true
        Site.subscribe(
          _self.name,
          _self.email,
        )
        .then(data => {
          console.log('email sent')
          _self.loading = false
          _self.name = ''
          _self.email = ''

          if (data && data.status !== 'ok') {
            _self.feedback = 'Oops. Something went wrong. Please try again later..'
            return
          }

          // _self.session = '' // open up to maintain session
          // _self.$toast.open({
          //   message: 'We will be contacting you via email or phone. Thanks!',
          //   position: 'is-bottom',
          //   type: 'is-success'
          // })
          _self.feedback = 'Subscribed. Thanks!'
          _self.loading = false
        })
        .catch(error => {
          console.log('invalid email', error)
          // this.error = error.error
          console.log(error)
          _self.captcha = ''

          // invalid recaptcha
          if (error && error.code === 103) {
            _self.feedback = error.error
            _self.loading = false
            return
          }

          // _self.$toast.open({
          //   duration: 5000,
          //   message: 'Oops. Something went wrong. Please email us directly at contact@clientmanagementprobation.com',
          //   position: 'is-bottom',
          //   type: 'is-warning'
          // })
          _self.feedback = 'Oops. Something went wrong. Please try again later..'
          _self.loading = false
        })
      }
    }
  },
  validations: {
    email: {
      required,
      email
    },
    name: {
      required
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.section-newsletter {
  // padding: 1rem 0;
  // margin-top: 3em;
  // margin-bottom: 3em;
  padding: 3em 0.75rem;
  background-color: $color-gray-lighter;

  @media screen and (min-width: $desktop) {
    // padding: 0 0.75rem;
  }

  & .cont-desc {
    // margin-top: 1.2rem;
    padding: 0;

    .fa {
      font-size: 2.5em;
      padding: 5px 15px;
      color: #aaaaaa;
    }

    .title {
      text-transform: uppercase;
    }

    @media screen and (min-width: $desktop) {
      padding: 0;
    }
  }

  .cont-form {
    margin-top: 1rem;
    // padding: 0rem 0.75rem;
    position: relative; // for button overlay

    @media screen and (min-width: $desktop) {
      padding: 0;
    }
    .field {
      padding-right: 15px;
    }

    &>p {
      // for feedback field only
      margin-top: 1rem;
      color: $color-gray-mid;
      text-align: center;
      font-weight: bold;
      @media screen and (min-width: $desktop) {
        text-align: left;
      }
    }

    span {
      display: block;
    }

    input, textarea {
      // border: 0;
      font-size: 0.8em;
      box-shadow: none;
      background: transparent;
      border: 0;
      border-bottom: 1px solid #bbbbbb;

      height: 3em;
      padding-left: 15px;
      padding-right: 15px;

      &[name='captcha'] {
        padding-left: 5px;
        padding-right: 5px;
        @media screen and (min-width: $desktop) {
          padding-left: 15px;
          padding-right: 15px;
        }
      }

      &::placeholder {
        color: #999999;
      }
      &:focus, &.is-focused, &:active, &.is-active {
        border-color: $color-black;
      }
    }

    textarea {
      height: auto;
      @media screen and (min-width: $tablet) {
        height: 175px;
      }
    }

    button.submit {
      position: inherit;
      width: 100%;
      border-radius: 0;
      // border: 2px solid $color-gray-mid;
      color: white;
      font-size: 0.8em;
      font-weight: bold;
      background-color: $color-primary-blue;
      height: auto;
      padding-top: 12px;
      padding-bottom: 12px;
      -webkit-transition: all 0.2s ease-in-out 0s;
      transition: all 0.2s ease-in-out 0s;
      opacity: 1;
      flex-direction: column;

      @media screen and (min-width: $desktop) {
         position: absolute;
         top: 0;
         right: 15px;
         width: 150px;
      }

      &:after {
        border-color: $color-gray-mid;
        border-right-color: transparent;
        border-top-color: transparent;
      }

      @media screen and (min-width: $desktop) {
        // width: 150px;
        // height: auto;
        // padding-top: 12px;
        // padding-bottom: 12px;
      }

      & p {
        color: white;
      }

      &:hover {
        background-color: $color-gray;
        -webkit-transition: all 0.2s ease-in-out 0s;
        transition: all 0.2s ease-in-out 0s;
        & p {
          color: #fff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// NewsletterSection.vue?2bd12eef